/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoControlCenterModelsCategories,
    ControlcenterMelcoControlCenterModelsCategoriesFromJSON,
    ControlcenterMelcoControlCenterModelsCategoriesFromJSONTyped,
    ControlcenterMelcoControlCenterModelsCategoriesToJSON,
    ControlcenterMelcoModelsCustomWarning,
    ControlcenterMelcoModelsCustomWarningFromJSON,
    ControlcenterMelcoModelsCustomWarningFromJSONTyped,
    ControlcenterMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsCategories
 */
export interface ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsCategories {
    /**
     * 
     * @type {Array<ControlcenterMelcoControlCenterModelsCategories>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsCategories
     */
    list: Array<ControlcenterMelcoControlCenterModelsCategories>;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCustomWarning>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsCategories
     */
    warning_list?: Array<ControlcenterMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsCategories
     */
    total: number;
}

export function ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsCategoriesFromJSON(json: any): ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsCategories {
    return ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsCategoriesFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsCategoriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsCategories {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ControlcenterMelcoControlCenterModelsCategoriesFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ControlcenterMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsCategoriesToJSON(value?: ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsCategories | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ControlcenterMelcoControlCenterModelsCategoriesToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ControlcenterMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


